import React from 'react';
import { Container, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { FormDialog } from '../../../../components/form-dialog';
import { Row } from '../../../../components/row';
import { Cell } from '../../../../components/cell';
import { ColorPalette } from '../../../../components/config';

interface DialogSupportErrorModalProps {
  open: boolean;
  onClose: () => void;
}

export function DialogSupportErrorModal(props: DialogSupportErrorModalProps) {
  const { open, onClose } = props;

  return (
    <FormDialog
      open={open}
      title="Fejl: Ingen opsummering"
      confirmButtonText="OK"
      onConfirmClick={onClose}
      maxWidth="md"
      sx={{
        '& .MuiDialogTitle-root': {
          px: '44px',
        },
      }}
      dontCapitalizeButtonTexts
    >
      <Container>
        <Box>
          <Row>
            <Cell size="full">
              <Box display="flex" alignItems="center" gap={3} my={1}>
                <FontAwesomeIcon size="2x" icon={faExclamationCircle} color={ColorPalette.Crimson} />
                <Box
                  sx={{
                    padding: '10px',
                    border: `solid 1px ${ColorPalette.Crimson}`,
                    borderRadius: 1,
                    flexGrow: 2,
                    backgroundColor: '#ffebee',
                  }}
                >
                  <strong>Der kunne ikke genereres en opsummering.</strong>
                  <br />
                  <br />
                  Dette kan skyldes, at transskriberingen ikke indeholder tilstrækkelig data til at generere en
                  meningsfuld opsummering.
                  <br />
                  <br />
                  Prøv venligst igen, eller skriv notatet manuelt.
                </Box>
              </Box>
            </Cell>
          </Row>
        </Box>
      </Container>
    </FormDialog>
  );
}
